import React from "react";
import { ReactComponent as AAALogo } from "assets/products/shared/icons/aaa-logo.svg";
import useIsMobile from "hooks/useIsMobile";
import MobileFooterContent from "./MobileFooterContent";
import DesktopFooterContent from "./DesktopFooterContent";
import { useProductContext } from "context/ProductContext";

interface FooterProps {
    className?: string;
}

const supportLinks = [
    {
        name: "Frequently Asked Questions",
        url: "https://www.aaalife.com/faq",
        external: true,
    },
    {
        name: "(855) 598-0890",
        url: "tel:8555980890",
        external: false,
    },
    {
        name: "Email Us",
        url: "mailto:membersvc@aaalife.com",
        external: false,
    },
];

const legalLinks = [
    {
        name: "Terms and Conditions",
        url: "https://www.aaalife.com/terms-and-conditions",
        external: true,
    },
    {
        name: "Disclosures",
        url: "https://www.aaalife.com/disclosures",
        external: true,
    },
    {
        name: "Privacy Policy",
        url: "https://www.aaalife.com/privacy-policy",
        external: true,
    },
];

// Mobile shows legal links first, then support links
const mobileLinks = [...legalLinks, ...supportLinks];

export const Footer = ({ className }: FooterProps) => {
    const isMobile = useIsMobile();
    const { isMLTA } = useProductContext();

    return (
        <footer className={`footer bg-gray-50 text-base-content w-full flex flex-col items-center ${className || ""}`}>
            <div
                className={`gap-y-0 gap-x-0 w-full max-w-content
    flex flex-col items-center text-center
    tablet:grid tablet:grid-cols-4 tablet:items-start tablet:text-left
    ${isMLTA ? "p-10 pb-4" : "p-10"}`}
            >
                {isMobile ? (
                    <MobileFooterContent links={mobileLinks} />
                ) : (
                    <DesktopFooterContent supportLinks={supportLinks} legalLinks={legalLinks} />
                )}

                <aside className="flex flex-col items-center gap-y-0 tablet:items-start text-center tablet:text-left tablet:pt-[54px]">
                    <a href="https://aaalife.com/" target="_blank" rel="noopener noreferrer">
                        <AAALogo className="w-[87px] h-[48px]" />
                    </a>
                    {!isMLTA && (
                        <p className="font-normal text-gray-900 leading-tight text-center tablet:text-left pt-8 tablet:pt-[57px]">
                            © 2025 AAA Life Insurance Company
                            <br />
                            All rights reserved
                        </p>
                    )}
                </aside>
            </div>
            {isMLTA && (
                <div className="w-full max-w-content px-10 pb-10 -mt-6">
                    <div className="open-sans font-semibold italic text-sm leading-[100%] tracking-[0%] flex flex-col gap-6">
                        <p>
                            Life insurance underwritten and annuities offered by AAA Life Insurance Company, Livonia, Michigan.
                            AAA Life Insurance Company is licensed in all states except NY. CA Certificate of Authority #07861.
                            Products and their features may not be available in all states.
                        </p>
                        <p>
                            Member Loyalty® Travel Accident Policy Form Series AAA-MLT-01, AAA-MLT-02, AAA-MLT-GP05,
                            AAA-MLT-06UT. In OR: AAA-MLT-01.
                        </p>
                        <p>Auto Club Loyalty® Travel Accident Policy Form Series AAA-MLT-GP05.</p>
                        <p className="font-normal not-italic">©2025 AAA Life Insurance Company, All Rights Reserved.</p>
                        <p className="font-normal not-italic">ALAN-30184-N25-XX</p>
                    </div>
                </div>
            )}
        </footer>
    );
};

export default Footer;
